import axios, { AxiosResponse } from 'axios';

import { IApiRequestParams } from 'types';

import { config } from 'miles.config';

import { handleError } from './instanceHelpers';

export const APIInstance = axios.create({
  timeout: 30000,
  baseURL: config?.apiURL,
});

APIInstance.interceptors.request.use((r) => r, handleError);
APIInstance.interceptors.response.use((r) => r, handleError);

export const apiGet = <D>({
  url,
  baseURL,
  headers,
  responseType,
}: Omit<IApiRequestParams, 'payload'>) => APIInstance.get<D, AxiosResponse<D>>(url, { responseType, baseURL, headers });

export const apiDelete = <D>({
  url,
  baseURL,
  headers,
}: Omit<IApiRequestParams, 'payload'>) => APIInstance.delete<D, AxiosResponse<D>>(url, { baseURL, headers });

export const apiPost = <D, P>({
  url,
  payload,
  baseURL,
  headers,
}: IApiRequestParams<P>) => APIInstance.post<D, AxiosResponse<D, P>, P>(url, payload, { baseURL, headers });

export const apiPatch = <D, P>({
  url,
  payload,
  baseURL,
  headers,
}: IApiRequestParams<P>) => APIInstance.patch<D, AxiosResponse<D, P>, P>(url, payload, { baseURL, headers });

export const apiPut = <D, P>({
  url,
  payload,
  baseURL,
  headers,
}: IApiRequestParams<P>) => APIInstance.put<D, AxiosResponse<D, P>, P>(url, payload, { baseURL, headers });
